import React from 'react';
import {
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { ILegalTransactionRelationshipRealEstate } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { LandRegisterQueryRow } from './LandRegisterQueryRow';
import { ILegalTransactionRelationship } from '../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationship';
import { ILegalTransactionFullObject } from '../../Interfaces/ILegalTransaction';
import { IDocumentDirectoryHasDocument } from '../../Interfaces/IDocumentDirectoryHasDocument';
import { IDocumentDirectory } from '../../Interfaces/IDocumentDirectory';
import { ILegalPhaseFullObject } from '../../Interfaces/ILegalPhase';
import {
  useAdministrativeUnits,
  useCourtAdministrativeUnitAssignments,
  useCourts,
} from '../../Aemter/hooks';
import { ILegalRequirementState } from '../../Interfaces/ILegalRequirementState';

interface IProps {
  legalTransaction: ILegalTransactionFullObject;
  relationship: ILegalTransactionRelationship;
  realEstateArray: ILegalTransactionRelationshipRealEstate[];
  setRealEstateArray: Function;
  documentArray: IDocumentDirectoryHasDocument[];
  documentDirectoryArray: IDocumentDirectory[];
  setDocumentArray: Function;
  setDocumentDirectoryArray: Function;

  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
  setLegalPhaseFullObjectArray: Function;
  legalReqStates: ILegalRequirementState[];
}

export const LandRegisterQueryTable: React.FC<IProps> = ({
  relationship,
  realEstateArray,
  setRealEstateArray,
  legalTransaction,
  documentArray,
  documentDirectoryArray,
  setDocumentArray,
  setDocumentDirectoryArray,
  legalPhaseFullObjectArray,
  setLegalPhaseFullObjectArray,
  legalReqStates,
}) => {
  const { courts, isLoadingCourts } = useCourts();
  const { administrativeUnits, isLoadingAdministrativeUnits } =
    useAdministrativeUnits();
  const {
    courtAdministrativeUnitAssignments,
    isLoadingCourtAdministrativeUnitAssignments,
  } = useCourtAdministrativeUnitAssignments();

  if (
    isLoadingCourts ||
    isLoadingAdministrativeUnits ||
    isLoadingCourtAdministrativeUnitAssignments
  ) {
    return <CircularProgress />;
  }

  if (!courts || !administrativeUnits || !courtAdministrativeUnitAssignments) {
    return (
      <Alert severity='error'>
        Es ist ein Fehler aufgetretten!
        <br />
        Die Gerichte konnten nicht bezogen werden.
      </Alert>
    );
  }

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Adresse / Begründung</TableCell>
            <TableCell sx={{ p: 0 }} width={150}>
              Amtsgericht
            </TableCell>
            <TableCell sx={{ p: 0 }} width={150}>
              Gemarkung
            </TableCell>
            <TableCell sx={{ p: 0 }} width={50}>
              Flur
            </TableCell>
            <TableCell sx={{ p: 0 }} width={50}>
              Flurstk.
            </TableCell>
            <TableCell sx={{ p: 0 }} width={50}>
              Blatt
            </TableCell>

            <TableCell width={90}>GB</TableCell>
            <TableCell width={90}>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {realEstateArray.map((res, idx) => (
            <LandRegisterQueryRow
              index={idx}
              legalTransaction={legalTransaction}
              key={`LandRegisterQueryRow-${res.idRealEstate}`}
              relationship={relationship}
              realEstate={res}
              realEstateArray={realEstateArray}
              setRealEstateArray={setRealEstateArray}
              documentArray={documentArray}
              documentDirectoryArray={documentDirectoryArray}
              setDocumentArray={setDocumentArray}
              setDocumentDirectoryArray={setDocumentDirectoryArray}
              legalPhaseFullObjectArray={legalPhaseFullObjectArray}
              setLegalPhaseFullObjectArray={setLegalPhaseFullObjectArray}
              legalReqStates={legalReqStates}
              courts={courts}
              adminUnit={administrativeUnits}
              courtsAdminAssign={courtAdministrativeUnitAssignments}
            />
          ))}
        </TableBody>
      </Table>
    </>
  );
};
